import { useMutation } from '../../index';
import permissions from '../../Apollo/permissions';
import { validate } from 'parameter-validator';
import { query as Pipelines } from '../../pipelines/useQueryPipelines';
import { query as StagedRevisions } from '../../pipelines/staged-revisions/useQueryStagedRevisions';

import {
  mutation as insertPipelineIntegrationMutation,
  buildVariables as buildInsertPipelineIntegrationVariables,
} from './insert-pipeline-integration-mutation-builder';

import { GET_CONSENT_CATEGORIES_AND_RELATIONSHIPS } from '../../consent-categories/useQueryConsentCategoriesAndRelationships';
import useTrackWithUser from '../../hooks/useTrackWithUser';

export default function useInsertPipelineIntegration(options = {}) {
  const [trackIntegrationAddedPipeline] = useTrackWithUser('integration_added_to_pipeline');
  const [executeMutation, response] = useMutation(insertPipelineIntegrationMutation, {
    successMsg: 'Integration added to pipeline.',
    context: { permission: permissions.createPipelineIntegration },
    ...options,
    refetchQueries: [
      {
        query: Pipelines,
        context: { permission: permissions.createPipelineIntegration },
      },
      {
        query: StagedRevisions,
        context: { permission: permissions.createPipelineIntegration },
      },
      {
        query: GET_CONSENT_CATEGORIES_AND_RELATIONSHIPS,
        context: { permission: permissions.readConsentCategory },
      },
    ],
  });

  const insertPipelineIntegration = args => {
    const { consentCategoryId, consentMode } = args;
    const { pipeline, integration, playbookId, pipelineVars, readyForDeploy } = validate(args, [
      'pipeline',
      'integration',
      'playbookId',
      'pipelineVars',
      'readyForDeploy',
    ]);
    return executeMutation({
      variables: buildVariables({
        pipeline,
        integration,
        playbookId,
        pipelineVars,
        readyForDeploy,
        consentCategoryId,
        consentMode,
      }),
    }).then(response => {
      if (!response.errors) {
        const { starterkitId } = integration;
        trackIntegrationAddedPipeline({
          starterkitId,
        });
      }
      return response;
    });
  };
  return [insertPipelineIntegration, response];
}

export function buildVariables({
  pipeline,
  integration,
  playbookId,
  pipelineVars,
  readyForDeploy,
  consentCategoryId,
  consentMode,
  disabled,
}) {
  const { id: pipelineId } = pipeline;
  const { id: integrationId } = integration;

  return buildInsertPipelineIntegrationVariables({
    pipelineId,
    integrationId,
    consentCategoryId,
    consentMode,
    playbookId,
    pipelineVars,
    readyForDeploy,
    disabled,
  });
}
